import { FormActions } from './FormActions';

// TODO: in v9, move styled() from FormActions.jsx to here
export var StyledFormActions = FormActions;